import conversationsService from '@/services/conversationsService.js'
import { EventBus } from '@/eventBus'
import usersService from '@/services/usersService.js'
import moment from 'moment'
import notifications from '@/libs/notifications'
import uniqid from 'uniqid'

const actions = {
  getAdvisers (vuexContext, status) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.getAdvisers(token, companyUID, appUUID, status)
  },
  getAppInfo (vuexContext, data) {
    const token = vuexContext.getters.token
    const company = vuexContext.getters.companyUuid
    const app = vuexContext.getters.appUuid
    return conversationsService.getAppInfo(token, company, app, data)
  },
  getFunnelData (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.getFunnelData(token, companyUID, appUUID, data)
  },
  getRooms (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.getRooms(token, companyUID, appUUID, data)
  },
  getStatistics (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.getStatistics(token, companyUID, appUUID, data)
  },
  getUserByPhoneRoom (vuexContext, phone) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.getUserByPhoneRoom(token, companyUID, appUUID, phone)
  },
  getUserDetails (vuexContext, { companyId, appId, userId }) {
    const token = vuexContext.getters.token
    const company = companyId || vuexContext.getters.companyUuid
    const app = appId || vuexContext.getters.appUuid
    const fromChat = 'chat'
    return usersService.getUser(token, company, app, userId, fromChat)
  },
  sendMessage (vuexContext, data) {
    const { media, mimetype, text } = data

    let type = 'chat'

    if (media) {
      switch (mimetype) {
        case 'image/jpg':
        case 'image/jpeg':
        case 'image/png':
          type = 'image'
          break
        case 'application/pdf':
          type = 'pdf'
          break
        case 'audio/ogg':
          type = 'audio'
          break
        case 'video/mp4':
          type = 'video'
          break
        default:
          type = 'others'
      }
    }

    const message = {
      createdAt: moment(),
      id: uniqid(),
      media: media || '',
      text: text,
      sender: 'advisor',
      roomId: vuexContext.state.selectedRoom,
      advisorId: vuexContext.rootState.auth.userKeybe.UUID,
      status: 'sending',
      type: type
    }

    vuexContext.commit('ADD_MESSAGES', message)

    vuexContext.state.socket.emit('chat', message, (err, data) => {
      if (err) {
        if (err.mustSendTemplate) {
          vuexContext.state.messages.pop()
          vuexContext.commit('SET_MUST_SEND_TEMPLATES', true)
          notifications.error('Debe iniciar una conversación')
        }
        return
      }

      if (!data) return
      message.status = ''
    })
  },
  async setPictureInPhotoSwipe (vuexContext, picture) {
    const p = {
      src: picture,
      w: 0,
      h: 0,
      title: ''
    }

    const img = document.createElement('img')
    img.style.display = 'none'

    img.onload = event => {
      // for chrome
      if (event.path) {
        p.w = event.path[0].naturalWidth
        p.h = event.path[0].naturalHeight
        // for firefox
      } else if (event.explicitOriginalTarget) {
        p.w = event.explicitOriginalTarget.naturalWidth
        p.h = event.explicitOriginalTarget.naturalHeight
      }

      vuexContext.commit('SET_PICTURES', p)
      document.getElementsByTagName('body')[0].removeChild(img)
      return true
    }

    img.src = picture
    document.getElementsByTagName('body')[0].appendChild(img)
  },
  startRoom ({ commit, state, rootState }, data) {
    return new Promise((resolve, reject) => {
      const { access, channel, text, userGuest, template, params } = data
      state.socket.emit('startRoom', {
        access,
        channel,
        text,
        userGuest,
        template,
        params
      }, (err, data) => {
        if (err) return reject(err)

        // TODO hacer leaveRoom
        if (state.selectedRoom === data.roomId) {
          const message = {
            createdAt: moment(),
            id: uniqid(),
            media: '',
            text: text,
            sender: 'advisor',
            roomId: state.selectedRoom,
            advisorId: rootState.auth.userKeybe.UUID,
            status: '',
            type: 'text'
          }

          commit('ADD_MESSAGES', message)
        } else {
          commit('SET_SELECTED_ROOM', data.roomId)
        }
        resolve(true)
      })
    })
  },
  takeConversation ({ commit, state }) {
    const { selectedRoom, socket } = state

    if (!selectedRoom) return

    socket.emit('roomAction', { roomId: selectedRoom, action: 'took' }, (err, data) => {
      if (err) return notifications.error(err.message)

      commit('SET_SELECTED_ROOM', data.roomId)
      return true
    })
  },
  transferAdviser (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.transferAdviser(token, companyUID, appUUID, data)
  },
  getChannelsInfo (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.getChannelsInfo(token, companyUID, appUUID)
  },
  getChannelsWithWhatsApp (vuexContext) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.getChannelsWithWhatsApp(token, companyUID, appUUID)
  },
  updateFbInfo (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.updateFbInfo(token, companyUID, appUUID, data)
  },
  updateSmoochInfo (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.updateSmoochInfo(token, companyUID, appUUID, data)
  },
  createSmoochInfo (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.createSmoochInfo(token, companyUID, appUUID, data)
  },
  createFbInfo (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.createFbInfo(token, companyUID, appUUID, data)
  },
  deleteFbInfo (vuexContext, data) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.deleteFacebookInfo(token, companyUID, appUUID)
  },
  updateCache (vuexContext, deleteWaitingAdvisor) {
    const token = vuexContext.getters.token
    const appUUID = vuexContext.getters.appUuid
    const companyUID = vuexContext.getters.companyUuid
    return conversationsService.updateCache(token, companyUID, appUUID, deleteWaitingAdvisor)
  },
  getConnectedEmails (vuexContext) {
    return new Promise((resolve, reject) => {
      const appUUID = vuexContext.getters.appUuid
      const companyUUID = vuexContext.getters.companyUuid
      conversationsService.getConnectedEmails(companyUUID, appUUID).then(response => {
        vuexContext.commit('SET_CALENDAR_EMAIL', response)
        resolve(response)
      }).catch((e) => {
        reject(e)
      })
    })
  }
}

const getters = {
  chatSettings (state) {
    if (!state.appInfo) return { finishOptions: [], quickResponses: [] }

    if (state.appInfo.extra_data.length > 0) {
      let chatSettings = state.appInfo.extra_data.filter(extraData => extraData.field === 'chat')

      if (!chatSettings[0] || !chatSettings[0].value) {
        return { finishOptions: [], quickResponses: [] }
      }

      chatSettings = JSON.parse(chatSettings[0].value)

      if (!chatSettings.finishOptions) chatSettings.finishOptions = []
      if (!chatSettings.quickResponses) chatSettings.quickResponses = []
      return chatSettings
    }
    return { finishOptions: [], quickResponses: [] }
  },
  conversationsIsConnected (state) {
    if (!state.socket) return false
    return state.socket.connected
  },
  appTags (state) {
    if (!state.appInfo) return []

    if (state.appInfo.extra_data.length > 0) {
      let appTags = state.appInfo.extra_data.filter(extraData => extraData.field === 'tags')

      if (!appTags[0] || !appTags[0].value) {
        return []
      }

      appTags = JSON.parse(appTags[0].value)

      return appTags
    }
    return []
  },
  userExtraDatasConversations (state, getters, rootState) {
    const { extraData } = state.user
    let ed = [...extraData]

    ed = ed.filter(extradata => extradata.field !== 'userNotesModule').filter(extradata => extradata.field !== 'token_provider')

    if (!state.user || !Array.isArray(ed)) return []
    const appExtradata = rootState.apps.appCustomExtradatas
    const length = appExtradata.length

    for (let i = 0; i < length; i++) {
      const result = ed.find(item => {
        return item.field === appExtradata[i].name
      })
      if (result) {
        result.extraDataCustomId = appExtradata[i].id
        result.tags = appExtradata[i].tags
        result.type = appExtradata[i].type
        result.options = appExtradata[i].options
      } else {
        ed.push({
          field: appExtradata[i].name,
          value: '',
          access: appExtradata[i].access,
          extraDataCustomId: appExtradata[i].id,
          tags: appExtradata[i].tags,
          type: appExtradata[i].type,
          options: appExtradata[i].options
        })
      }
    }
    return ed
  },
  userNotes (state) {
    const { extraData } = state.user
    if (!extraData) return []
    const ed = [...extraData]
    const userNotes = ed.find(item => item.field === 'userNotesModule')
    return userNotes ? JSON.parse(userNotes.value) : []
  }
}

const mutations = {
  ADD_DRAFT (state, draft) {
    const tempDraft = state.drafts.find(item => item.room === draft.room)
    tempDraft ? tempDraft.text = draft.text : state.drafts.push(draft)
  },
  ADD_MESSAGES (state, message) {
    state.messages.push(message)
  },
  REMOVE_DRAFT (state, room) {
    state.drafts.filter(draft => draft.room !== room)
  },
  SET_CHANNELS_WITH_WHATSAPP (state, value) {
    state.channelsWithWhatsApp = value
  },
  SET_APP_INFO (state, appInfo) {
    state.appInfo = appInfo
  },
  SET_AUTO_STARTS (state, autoStarts) {
    state.autoStarts = autoStarts
  },
  SET_INIT_CONVERSATION (state, data) {
    state.initConversation = data
  },
  SET_MESSAGES (state, messages) {
    state.messages = messages
  },
  SET_MUST_SEND_TEMPLATES (state, value) {
    state.mustSendTemplate = value
  },
  SET_PICTURES (state, picture) {
    state.pictures = [picture]
    EventBus.$emit('openPhotoSwipe')
  },
  SET_ROOM_INFO (state, roomInfo) {
    state.roomInfo = roomInfo
  },
  SET_SELECTED_ROOM (state, roomId) {
    state.selectedRoom = roomId
  },
  SET_SOCKET_CONVERSATIONS (state, socket) {
    state.socket = socket
  },
  SET_CONVERSATIONS_STATISTICS (state, statistics) {
    state.statistics = statistics
  },
  SET_CHANNELS_INFO (state, channelsInfo) {
    state.channelsInfo = channelsInfo
  },
  SET_CONVERSATIONS_USER (state, user) {
    state.user = user
  },
  SET_FUNNEL_DATA (state, funnel) {
    state.funnelData = funnel
  },
  SET_ROOM_STATUS (state, status) {
    state.roomInfo.status = status
  },
  SET_CALENDAR_EMAIL (state, data) {
    state.calendarEmail = data
  }
}

const state = {
  appInfo: '',
  autoStarts: [],
  channelsInfo: null,
  channelsWithWhatsApp: [],
  drafts: [],
  funnelData: {
    conversationsByStage: [],
    ended: []
  },
  initConversation: null,
  messages: [],
  mustSendTemplate: false,
  pictures: [],
  roomInfo: '',
  selectedRoom: '',
  socket: null,
  statistics: null,
  user: '',
  calendarEmail: []
}

export default { actions, getters, mutations, state }
